module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold-Italic.25de0ca7.eot";